import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography
} from '@material-tailwind/react'
import PropTypes from 'prop-types'
import { confirmable } from 'react-confirm'
import { FiCheckCircle } from 'react-icons/fi'

export const Modal = ({ show = true, proceed = () => { }, title, description }) => {
  return (
    <Dialog open={show} size='sm'>
      <DialogHeader className='pb-0'>
        <div className='flex justify-center items-center w-14 h-14 bg-green-50 border-green-50 p-3 rounded-[28px] text-green-900'>
          <div className='flex items-center justify-center bg-green-100 rounded-[28px] p-3 w-10 h-10'>
            <FiCheckCircle
              size='2rem'
            />
          </div>
        </div>
      </DialogHeader>

      <DialogBody className='flex flex-col gap-3'>
        <Typography variant='h5' className='text-black'>{title}</Typography>
        <Typography variant='small'>{description}</Typography>
      </DialogBody>

      <DialogFooter>
        <Button color='blue' fullWidth onClick={proceed}>Aceptar</Button>
      </DialogFooter>
    </Dialog>
  )
}

Modal.propTypes = {
  show: PropTypes.bool,
  proceed: PropTypes.func,
  confirmation: PropTypes.string,
  options: PropTypes.object,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
}

export const SuccessConfirmationModal = confirmable(Modal)
